module.exports = __webpack_public_path__ + "img/moni.e4839ef8.png";